export enum ImageSource {
  OwnDevice = 'ownDevice',
  KristaKroma = 'kristaKroma',
}
